import { Box } from '@mui/material';
import { string } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import authCompany from 'store/selectors/authCompany';
import connector from './connector';
import CustomPaper from './CustomPaper';
import IAcceptTermsButton from './IAcceptTermsButton';
import LegalDoc from './LegalDoc';

const rootSx = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
};

const termsBlockSx = {
  width: 'calc(min(1240px, 80vw))',
  margin: '20px 0',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

const actionsSx = {
  marginTop: '2em',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const LegalDocScene = ({ doc }) => {
  const company = useSelector(authCompany);
  const navigate = useNavigate();
  const acceptTerms = () => {
    navigate('/welcome/legal', { state: { accepted: true } });
  };

  return (
    <Box component="section" sx={rootSx}>
      <Box sx={termsBlockSx}>
        <CustomPaper>
          <LegalDoc>{company[doc]}</LegalDoc>
          <Box sx={actionsSx}>
            <IAcceptTermsButton onClick={acceptTerms} />
          </Box>
        </CustomPaper>
      </Box>
    </Box>
  );
};

LegalDocScene.propTypes = {
  doc: string.isRequired,
};

export default connector(LegalDocScene);
